import { createQueryKey } from '../../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../../query/types';

const ticketingDashboardEventDatesKeys = <T extends QueryKey>(keys: T) => {
  const key = [...keys, 'event_dates'] as const;
  return createQueryKey({
    all: [...key] as const,
    export: [...key, 'export'] as const,
  });
};

export { ticketingDashboardEventDatesKeys };
